"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { AspectRatio } from "@/components/ui/aspect-ratio";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function MeetYourDoula() {
  const {
    ref: imageRef,
    isVisible: isImageVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: textRef,
    isVisible: isTextVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="230192" id="meet-your-doula-joss" className="py-20 lg:py-32 overflow-hidden bg-background">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-24 items-center">
          
          {}
          <div ref={imageRef} className={`relative transition-all duration-1000 ease-out ${isImageVisible ? "opacity-100 translate-x-0" : "opacity-0 -translate-x-12"}`}>
            <div className="relative rounded-3xl overflow-hidden shadow-xl shadow-shadow-color/5">
              <AspectRatio ratio={4 / 5}>
                <img src="https://sunny-rooster.10web.cloud/wp-content/uploads/2026/05/JJ-picture.png" alt="Jocelyn Smith, a warm and professional birth doula in West Palm Beach" className="object-cover w-full h-full" />
              </AspectRatio>
              {}
              <div className="absolute inset-0 bg-gradient-to-tr from-background/10 to-transparent mix-blend-overlay pointer-events-none"></div>
            </div>
            
            {}
            <div className="absolute -z-10 -bottom-8 -left-8 w-2/3 h-2/3 bg-primary/5 rounded-3xl blur-3xl"></div>
          </div>

          {}
          <div ref={textRef} className={`flex flex-col justify-center transition-all duration-1000 delay-200 ease-out ${isTextVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
            <span className="text-primary font-semibold tracking-wider uppercase text-sm mb-4 block">
              A Heart for Motherhood
            </span>
            <h2 className="text-4xl font-bold text-foreground mb-8 leading-tight !font-serif md:text-5xl lg:text-6xl">
              Meet Your Doula, Joss
            </h2>

            <div className="prose prose-lg prose-p:text-foreground/80 max-w-none">
              <p className="text-lg leading-relaxed mb-8 first-letter:text-7xl first-letter:font-default first-letter:font-bold first-letter:text-primary first-letter:float-left first-letter:mr-4 first-letter:mt-[-0.15em] first-letter:leading-none">
                In the quiet moments of transition, I am here to hold space for your journey into motherhood. My name is Jocelyn, but most call me Joss. As a certified birth and postpartum doula in West Palm Beach, my mission is to transform the fear of the unknown into the joy of the expected, providing a steady hand and a calm heart when you need it most.
              </p>

              <blockquote className="border-l-4 border-primary pl-6 py-2 my-10 rounded-r-lg pr-4 bg-primary">
                <p className="text-xl md:text-2xl text-foreground font-default font-medium italic leading-snug m-0">
                  "Birth is not just about making babies. It's about making mothers—strong, competent, capable mothers who trust themselves and know their inner power."
                </p>
              </blockquote>

              <p className="text-lg leading-relaxed mb-10">
                My approach combines evidence-based lactation counseling with intuitive emotional support. Whether we are navigating your first latch or preparing for a peaceful VBAC, I am dedicated to honoring your unique birth plan. I believe that every family deserves a birth experience that feels safe, supported, and sacred, grounded in the warmth of personalized care.
              </p>
            </div>

            <div className="mt-4">
              <Button asChild size="lg" className="rounded-full px-8 text-base h-12 bg-primary hover:bg-primary/90 text-primary-foreground transition-colors">
                <Link to="https://hello.dubsado.com:443/public/appointment-scheduler/662a79049b3568003af78fe0/schedule">Lets Talk</Link>
              </Button>
            </div>
          </div>

        </div>
      </div>
    </section>;
}